export interface CalificacionRubro {
  key: string;
  name: string;
  pct: number;
  score: number;
}

export interface CalificacionDetalle {
  periodId: string;
  periodName: string;
  periodNumber: number;
  subjectId: string;
  subjectName: string;
  hasData: boolean;
  finalGrade: number | null;
  participationPoints: number;
  rubros: CalificacionRubro[];
}

export interface CalificacionesState {
  studentId: string | null;
  grades: CalificacionDetalle[];
  loading: boolean;
  error: string | null;
}

export const initialCalificacionesState: CalificacionesState = {
  studentId: null,
  grades: [],
  loading: false,
  error: null,
};
